<div class="modal-header">
    <h4 class="modal-title">Upload Documents</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="card-body p-0">

        <!-- ── LIST VIEW ── -->
        <div *ngIf="!openDocumentAdd">

            <!-- Filters -->
            <div class="row mb-3">
                <div class="col-xl-2">
                    <div class="form-group">
                        <label class="control-label">From Date</label>
                        <input type="text" autocomplete="off" placeholder="DD-MM-YYYY"
                            bsDatepicker #dp="bsDatepicker"
                            (focus)="dp.show()" (focus)="dp1.hide()"
                            [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}"
                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
                            [maxDate]="maxDate"
                            class="form-control form-control-sm"
                            onkeypress="return event.charCode == 8">
                    </div>
                </div>
                <div class="col-xl-2">
                    <div class="form-group">
                        <label class="control-label">To Date</label>
                        <input type="text" autocomplete="off" placeholder="DD-MM-YYYY"
                            bsDatepicker #dp1="bsDatepicker"
                            (focus)="dp1.show()" (focus)="dp.hide()"
                            [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}"
                            [minDate]="fromDate"
                            [maxDate]="maxDate"
                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
                            class="form-control form-control-sm"
                            onkeypress="return event.charCode == 8">
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">File Type</label>
                        <select class="form-control form-control-sm" [(ngModel)]="selectedFileTypeId" [ngModelOptions]="{standalone: true}">
                            <option value="">All</option>
                            <option *ngFor="let ft of fileTypeList" [value]="ft.id">{{ ft.file_type }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-xl-4 mt-2">
                    <div class="form-group">
                        <button class="btn btn-sm btn-primary mt-4" (click)="fetchDocuments()">
                            <i class="fa fa-search"></i>&nbsp;Search
                        </button> &nbsp;
                        <button class="btn btn-sm btn-success mt-4" (click)="openDocumentAdd = true">
                    <i class="fa fa-upload"></i>&nbsp;Upload Document
                </button>
                    </div>
                </div>
            </div>

            <!-- Documents Table -->
            <div class="table-responsive">
                <table datatable *ngIf="dtRender" class="table table-striped table-bordered table-sm" style="width:100%;">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Patient Name</th>
                            <th>Document Type</th>
                            <th>Document Name</th>
                            <th>Upload Date</th>
                            <th class="singleLine" *ngIf="!careContextHide && isNDHMEnable">Link Care Context</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let doc of documentList; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ doc?.patient_name}}</td>
                            <td>{{ doc?.file_type }}</td>
                            <td>{{ doc?.file_name }}</td>
                            <td>{{ doc?.report_date | date:'dd-MM-yyyy' }}</td>
                             <td  *ngIf ="isNDHMEnable && !careContextHide && (doc?.health_id == '' || doc?.health_id == null)" style="text-align: center !important;">No HealthId</td>
                             <td  *ngIf ="isNDHMEnable && !careContextHide && (doc?.health_id!== '' && doc?.health_id!== null && doc.is_carecontext_linked==true)" style="text-align: center !important; color: green;">Care Context Added</td>
                             <td  *ngIf ="isNDHMEnable && !careContextHide && (doc?.health_id!== '' && doc?.health_id!== null && doc.is_carecontext_linked==false)"  style="text-align: center !important;"><button class="btn btn-sm btn-primary"  (click)="openLinkwithAbhaConsultation(doc)">Link Care Context</button></td>
                            <td>
                                <a class="text-primary pointer mr-2" style="cursor:pointer;" (click)="viewDocument(doc)">
                                    <i class="fa fa-eye"></i>  &nbsp;&nbsp;
                                </a>
                                <a class="text-success pointer mr-2" style="cursor:pointer;" (click)="downloadDocument(doc)">
                                    <i class="fa fa-download"></i> &nbsp;&nbsp;
                                </a>
                                <a class="text-danger pointer" style="cursor:pointer;" (click)="deleteDocument(doc)">
                                    <i class="fa fa-trash"></i> 
                                </a>
                            </td>
                            
                        </tr>
                        <tr *ngIf="documentList.length === 0">
                            <td colspan="6" class="text-center">No records found.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

         
        </div>

        <!-- ── UPLOAD VIEW ── -->
        <div *ngIf="openDocumentAdd">

            <div class="row">
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">Report Date <span class="text-danger">*</span></label>
                        <input type="text" autocomplete="off" placeholder="DD-MM-YYYY"
                            bsDatepicker #dpUpload="bsDatepicker"
                            (focus)="dpUpload.show()"
                            [(ngModel)]="uploadReportDate"
                            [maxDate]="maxDate"
                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
                            class="form-control form-control-sm"
                            onkeypress="return event.charCode == 8">
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">File Type <span class="text-danger">*</span></label>
                        <select class="form-control form-control-sm" [(ngModel)]="uploadFileType">
                            <option value="">Select File Type</option>
                            <option *ngFor="let ft of fileTypeList" [value]="ft.id">{{ ft.file_type }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">Select File <span class="text-danger">*</span></label>
                        <input type="file" class="form-control form-control-sm"
                            accept=".jpg,.jpeg,.png,.pdf"
                            (change)="onFileSelected($event)">
                        <small class="text-muted">jpg, jpeg, png, pdf only</small>
                    </div>
                </div>
                  <div class="col-xl-3 mt-4">
               
                <button class="btn btn-sm btn-danger mr-2 mt-2" (click)="cancelUpload('cancel')">
                    <i class="fa fa-times"></i>&nbsp;Clear
                </button>
                <button class="btn btn-sm btn-primary mt-2" (click)="submitUpload()">
                    <i class="fa fa-upload"></i>&nbsp;Submit
                </button>
            </div>
            </div>
          
        </div>

    </div>
</div>

<div class="modal-footer">
     <button class="btn btn-sm btn-outline-dark mr-2" (click)="cancelUpload('back')" *ngIf="openDocumentAdd">
                    <i class="fa fa-arrow-left"></i>&nbsp; Back
                </button>
    <button type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
</div>
